import { useHead } from '@unhead/vue';

export const SITE_NAME = 'WinCard';
export const SITE_URL = (process.env.VUE_APP_SITE_URL || 'https://wincard.app').replace(/\/$/, '');
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

/**
 * Sets per-route title, meta description, canonical URL, Open Graph / Twitter
 * tags, and optional JSON-LD. Pass a getter function (not a plain object) so
 * values stay reactive when a route component is reused across param changes
 * (e.g. navigating between /guides/:slug entries).
 */
export function useSeo(input) {
  useHead(() => {
    const { title, description, path, image = DEFAULT_OG_IMAGE, type = 'website', jsonLd = null } =
      typeof input === 'function' ? input() : input;

    const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME}: Digital loyalty cards for Apple & Google Wallet`;
    const url = `${SITE_URL}${path}`;

    return {
      title: fullTitle,
      meta: [
        { name: 'description', content: description },
        { property: 'og:type', content: type },
        { property: 'og:site_name', content: SITE_NAME },
        { property: 'og:title', content: fullTitle },
        { property: 'og:description', content: description },
        { property: 'og:url', content: url },
        { property: 'og:image', content: image },
        { property: 'og:image:width', content: '1200' },
        { property: 'og:image:height', content: '630' },
        { property: 'og:image:type', content: 'image/png' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: fullTitle },
        { name: 'twitter:description', content: description },
        { name: 'twitter:image', content: image },
      ],
      link: [{ rel: 'canonical', href: url }],
      script: jsonLd ? [{ type: 'application/ld+json', children: JSON.stringify(jsonLd) }] : [],
    };
  });
}
